import type { FaireProductEntity } from "../../entity_types/product";

export const p_krcyezzdry: FaireProductEntity = {
  token: "p_krcyezzdry",
  type: "product",
  name: "MID WAISTED WIDE LEG STRIPED PANTS",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/f921872c9d1235fbd9244a3b7adb563644cc1f32a6f31409451216076e3294a1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7b3e0b982f149ae08f7f4b2b49d63c8578331d72ad9121f212a4719b92c90464.jpeg",
    "https://cdn.faire.com/fastly/c836698ec64558809d1697152b4ca2540d5b422b88f2dd264dd3a4ca2989c381.jpeg",
    "https://cdn.faire.com/fastly/2a92880da6fe119b670aa1949d2b45a262457c7fccafab6c7f6c51f3d8d51a9e.jpeg",
    "https://cdn.faire.com/fastly/b2756280666e64dd4acdab4f0f5c2be9455d5c8727eac5dd66fbcb635fce07bc.jpeg",
    "https://cdn.faire.com/fastly/cb2434c19f3e9a25c8260b7aff6b1f06691a78ed478b5bf0281974ffc80222e4.jpeg",
    "https://cdn.faire.com/fastly/45c706fac3a1119740a7f5541678061441a42043b42ac2daea43fe36e5b4f295.jpeg",
    "https://cdn.faire.com/fastly/9a70525e6a2eeef71280cb9de4f0c0dba3fcdeec3ce315408a007552ba0eb032.jpeg",
    "https://cdn.faire.com/fastly/b80e8cff020c3dfadbc0c96d4795b19f2d399bf63b793508ee3e427d43af3f35.jpeg",
    "https://cdn.faire.com/fastly/a789c1efbefe77ef4bb62f304b09646c443fc05dca1c13640bfec56d37c33201.jpeg",
    "https://cdn.faire.com/fastly/5ef830e0f52d5205fbda6b74ba56a9d3f371305ff9d3c52358f104b06d4a20bc.jpeg",
    "https://cdn.faire.com/fastly/44bb5334101c08b19984e81281780ae5e902876d64def31210d24a223ed6fe66.jpeg",
    "https://cdn.faire.com/fastly/22168309cd21e7581da2053e0cf097b6ef37bba180d4e7701ef7d2974c1c3b9e.jpeg",
    "https://cdn.faire.com/fastly/d32cf26e04ff09af31781d19b33fe1a3aa79c894902de4d419c04ef71df40735.jpeg",
  ],
  priceDollars: 180,
  description:
    '**PANTS ONLY**\n\n(MATCHING SET WITH: IT6773)\n\nMODEL IS WEARING A SIZE SMALL\n\nMODEL SPECS\nHEIGHT: 5\'8"\nBUST: 32A\nWAIST: 24"\nHIPS: 34"',
  tags: [],
  msrpDollars: 360,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:17.395Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
